export default function(x) {
  return x<0 ? -1 : 1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/sign.js
// module id = 6
// module chunks = 0